import { render, staticRenderFns } from "./ViewReportStudent.vue?vue&type=template&id=18d9393c&scoped=true"
import script from "./ViewReportStudent.vue?vue&type=script&lang=js"
export * from "./ViewReportStudent.vue?vue&type=script&lang=js"
import style0 from "./ViewReportStudent.vue?vue&type=style&index=0&id=18d9393c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d9393c",
  null
  
)

export default component.exports